export default __webpack_public_path__ + "static/media/player_1_eliminated.45ac43d4.png";